import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { AdminStatistics } from '../../components/AdminStatistics'

export const Route = createFileRoute('/admin/kpis')({
  component: () => (
    <AdminStatistics />
  ),
})
